import React, {useRef} from 'react';
import jwtDecode from 'jwt-decode';
import urlQueryParser from '../components/Parsers/urlQueryParser';
import {fetchController} from '@xpertdox_js/xdcomponents';
import config from '../config/axios.config';
import axios from 'axios';
import {useHistory} from 'react-router-dom';
import setAuthToken from '../setAuthToken'


const UserContext = React.createContext();

// reducer
const reducer = (state, action) => {
  const clearedUser = {name: null, email: null, loggedIn: false, entries: null};
  switch(action.type) {

    // login
    case 'login':
    sessionStorage.setItem('jwtToken', action.token);
    setAuthToken(action.token)
    let result = jwtDecode(action.token);
    // console.log(result, 'decoded result')
    // this below is done because if the user selects an instance
    // in the side navigation bar and refreshes stanford
    // gets selected automatically but istead it should be what user selects
    if (sessionStorage.getItem('lastInstance') !== null) {
      result.instance = sessionStorage.getItem('lastInstance')
    }

    return {
      ...state,
      id: result.id,
      email: result.email,
      instance: result.instance,
      division: result.division,
      userTitle: result.userTitle,
      affiliation: result.affiliation,
      phoneNumber: result.phoneNumber,
      name: result.name,
      accountType: result.accountType,
      isXDAdmin: result.isXDAdmin,
      loggedIn: true,
    };

    // update user
    case 'updateUser':
      if (action.property === 'instance' && action.value) {
        sessionStorage.setItem('lastInstance', action.value)
      }
      return {
        ...state,
        [action.property] : action.value
      }
    // logout
    case 'logout':
      // sessionStorage.removeItem('jwtToken');
      // setAuthToken(false)
      axios.get(config.ssoApi + '/backend/rt/user/logout/' + state.id)
      .then((res) => {
        sessionStorage.removeItem('jwtToken');
        localStorage.removeItem('lastInstance')
        setAuthToken(false)
        window.location = config.ssoUrl + `?app=xt_console?instance=` + action.instance+`?redirect_uri=${config.localUrl}`;
      })
      .catch(err => {
        console.error(err);
        return clearedUser;
      });
    default: return clearedUser;
  }
};


// provider
const UserContextProvider = props => {

  const queries = urlQueryParser();
  // console.log('queries', queries)
  const [state, dispatch] = React.useReducer(reducer, {
    name: null,
    email: null,
    loggedIn: false,
    entries: null,
  });
  // console.log(state)
  const path = document.location.pathname.split('/');
  const urlInstance = path[1] === 'trial_list' ? path[2] : path[1];
  const appHistory = useHistory();
  const failed = React.useRef(false);
  const tokenHasBeenSet = sessionStorage.jwtToken ? true : false;
  const tokenHasExpired = tokenHasBeenSet
  ? jwtDecode(sessionStorage.jwtToken).exp < (Date.now() / 1000) : false;

  // direct to login automatically
  if (!state.loggedIn
    && !queries.session
    && (!tokenHasBeenSet || tokenHasExpired)
    && !failed.current)
    window.location = config.ssoUrl + '/?app=xt_console?instance=' + urlInstance;

  // login if token in local storage && is still valid
  if (!queries.session
    && sessionStorage.jwtToken
    && !state.loggedIn) {
      if (tokenHasExpired) dispatch({type: 'logout'})
      else {
        // console.log('UserContext -> login using cookie')
        dispatch({
          type: 'login',
          token: sessionStorage.jwtToken,
        })
      }
    }

  // if not loggedIn && session in url then login using session
  const fetcher = useRef(fetchController({
    axiosConfig: config,
    base: config.ssoApi,
    url: '/backend/rt/user/activateSession/',
    endpoint: queries.session,
    method: 'get',
  }))
  if (queries.session && fetcher.current.status !== 'complete' && fetcher.current.status !== 'fetching') {
    // console.log('UserContext --> login using session', window.location, appHistory);
    fetcher.current.fetch()
    .then(res => {
      console.log(res, "RES")
      setTimeout(() => {console.log('wait up')}, 100000)
      if (res.data && res.data.token) dispatch({
        type: 'login',
        token: res.data.token
      });
      if (queries.nct) {
        let nctValue = queries.nct;
        appHistory.push(appHistory.location.pathname + 'trials/overview/' + nctValue)
      } else {
        appHistory.push(appHistory.location.pathname);
      }
    })
    .catch(err => {
      console.error(err);
      failed.current = true;
      appHistory.push(appHistory.location.pathname + 'session_error');
    })
  }

  // if not loggedIn && no session in url then send to login page with appID as query
  // console.log(sessionStorage.jwtToken, queries.session, state.loggedIn, window.location, config.ssoUrl, failed.current, urlInstance, "TEST")
  if (!sessionStorage.jwtToken
    && !queries.session
    && !state.loggedIn
    && window.location !== config.ssoUrl + '?app=xt_console'
    && !failed.current)
    window.location = config.ssoUrl + `?app=xt_console?instance=` + urlInstance+`?redirect_uri=${config.localUrl}`;

  // logout on instance change without privaledges
  if (
      state.instance
      && urlInstance !== ""
      && state.instance !== urlInstance
      && !state.isXDAdmin)
    dispatch({type: 'logout'});

  // set instance in localStorage if not set or instance !== localStorage
  // console.log(state.instance, localStorage.lastInstance, urlInstance, "INSTANCE")
  if ((state.instance && !localStorage.lastInstance)
    || (state.instance && localStorage.lastIntance && state.instance !== localStorage.lastInstance))
    localStorage.setItem('lastInstance', state.instance);

  return(
    <UserContext.Provider
      value={{
        user: state,
        userAction: dispatch
      }}
    >
      {props.children}
    </UserContext.Provider>
  )
}

const UserContextConsumer = UserContext.Consumer;

export {UserContext, UserContextProvider, UserContextConsumer};
